<div class="form-input-file">
  <label [for]="id" class="form-label">{{label}}</label>
  <input class="form-control" type="file" [id]="id" [multiple]="multiple" [disabled]="disabled" [required]="required">
  <p class="caption-text">{{caption}}</p>
</div>